import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useAuthStore } from '@/stores/authStore'
import { Toaster } from '@/components/ui/toaster'
import { AdminGuard } from '@/components/AdminGuard'
import { AdminLayout } from '@/layouts/AdminLayout'
import { Login } from '@/pages/Login'
import { AccessDenied } from '@/pages/AccessDenied'
import { Dashboard } from '@/pages/Dashboard'
import { OrganizationList } from '@/pages/organizations/OrganizationList'
import { OrganizationCreate } from '@/pages/organizations/OrganizationCreate'
import { OrganizationDetail } from '@/pages/organizations/OrganizationDetail'
import { UserDetail } from '@/pages/users/UserDetail'
import { System } from '@/pages/System'
import { Usage } from '@/pages/Usage'
import { Audit } from '@/pages/Audit'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
    },
  },
})

function RootLayout() {
  const restoreSession = useAuthStore((s) => s.restoreSession)

  useEffect(() => {
    restoreSession()
  }, [restoreSession])

  return <Outlet />
}

const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      { path: '/login', element: <Login /> },
      { path: '/access-denied', element: <AccessDenied /> },
      {
        element: (
          <AdminGuard>
            <AdminLayout />
          </AdminGuard>
        ),
        children: [
          { index: true, element: <Dashboard /> },
          { path: 'organizations', element: <OrganizationList /> },
          { path: 'organizations/new', element: <OrganizationCreate /> },
          { path: 'organizations/:orgId', element: <OrganizationDetail /> },
          { path: 'organizations/:orgId/users/:userId', element: <UserDetail /> },
          { path: 'system', element: <System /> },
          { path: 'usage', element: <Usage /> },
          { path: 'audit', element: <Audit /> },
        ],
      },
    ],
  },
])

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster />
    </QueryClientProvider>
  )
}
